import jwt_decode from 'jwt-decode';

export const getNonce = (token: string) => {
  return jwt_decode<any>(token)?.nonce;
};
